import type { AnswerChoice, BoardAnswer } from '@cf/shared'

/**
 * Set or clear one wording's verdict inside a board answer.
 *
 * Clearing has to produce an explicit null. The obvious spelling, leaving the
 * key out (or setting it to undefined, which is the same thing once
 * JSON.stringify has run), reaches the server as a patch that never mentions
 * that wording, so the stored verdict survives and reappears on the next
 * reload. Reported from the running app, 2026-08-04.
 */
export function withVariantVerdict(
  variants: BoardAnswer['variants'],
  variant: string,
  value: AnswerChoice | null,
): Record<string, AnswerChoice | null> {
  return { ...variants, [variant]: value }
}
